const $ = jQuery.noConflict();

'use strict';
const Video = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$domVideo: $('#video'),
	$domVideoBlock: $('.js-video, js-video-all'),
	$domVideoIcon: $('.js-video-block__box-icon'),
	$domVideoWrap: $('.js-video-block__box-wrap'),

	/** @description Initialize */
	init: function() {
		if (this.$domVideoBlock.length > 0) {
			this.videoPlayPause();
			this.videoPlayPauseAll();
			this.videoPlayPauseSpecial();
			this.videoProgressBar();
			this.videoPercentage();

			//remove controls if FF
			if(navigator.userAgent.indexOf('Firefox') !== -1) {
				$('.js-video').removeAttr('controls');
			}
		}

		//site-footer__box-link--media has to be added on the link in the dashbord/Appearance/Menus
		$('.site-footer__box-link--media').on('click', function() {
			$('.js-video-block__box-icon').css('opacity', '0');
		});
		$('.js-video-all').on('click', function() {
			$('#video-all').trigger('pause');
			$('.js-video-block__box-icon').css('opacity', '1');
			$('#video-all').parent().addClass('show-overlay');
		});
		$('.js-video-overlay').on('click', function() {
			$(this).parent().removeClass('show-overlay');
			$('#video-all').trigger('play');
			$('.js-video-block__box-icon').css('opacity', '0');
		});
	},

	videoPlayPause: function() {
		$('.js-video').on('click touchstart', function(e) {
			e.preventDefault();
			if (document.getElementById('video').paused) {
				document.getElementById('video').play();
				Video.$domVideoIcon.css('opacity', '0');
				$('.js-video-block__placeholder-img').css('opacity', '0');
			} else {
				document.getElementById('video').pause();
				Video.$domVideoIcon.css('opacity', '1');
				$('.js-video-block__placeholder-img').css('opacity', '1');
			}
		});
	},

	videoPlayPauseAll: function() {
		$('.js-video-block__box-wrap-all').on('click', function() {
			if (document.getElementById('video-all').paused) {
				document.getElementById('video-all').play();
				Video.$domVideoIcon.css('opacity', '0');
			} else {
				document.getElementById('video-all').pause();
				Video.$domVideoIcon.css('opacity', '1');
			}
		});
	},

	videoPlayPauseSpecial: function() {
		$('.site-footer__box-link--media').on('click', function() {
			document.getElementById('video-all').play();
			Video.$domVideoIcon.css('opacity', '0');
		});
		$('.js-video-holder__all-icon').on('click', function() {
			document.getElementById('video-all').pause();
		});
	},

	videoProgressBar: function() {
		const vid = document.getElementById('video-all');

		$('#custom-seekbar').on('click', function(e){
			const offset = $(this).offset();
			const left = (e.pageX - offset.left);
			const totalWidth = $('#custom-seekbar').width();
			const percentage = (left / totalWidth);
			const vidTime = vid.duration * percentage;
			vid.currentTime = vidTime;
		});
	},

	videoPercentage: function() {
		const vid = document.getElementById('video-all');
		vid.ontimeupdate = function() {
			const percentage = (vid.currentTime / vid.duration) * 100;
			$('#custom-seekbar span').css('width', percentage +'%');
			$('#custom-seekbar span').css('display', 'block');
		};
	},
};

export default Video;